import React from 'react'
import { JsonLd, JsonLdProps } from './JsonLd'
import { WebPage } from './types'

export interface WebPageJsonLdProps extends JsonLdProps, WebPage {}

export const WebPageJsonLd: React.FC<WebPageJsonLdProps> = ({ type = 'WebPage', keyOverride, ...rest }) => (
  <JsonLd type={type} keyOverride={keyOverride} {...rest} scriptKey="WebPage" />
)
